export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const INSERT = 'INSERT';
export const GET_ALL = 'GET_ALL';
export const FETCH_ALL = 'FETCH_ALL';
export const LOGOUT = 'LOGOUT';
export const AUTH = 'AUTH';
export const CREATEREVIEW='CREATEREVIEW';
export const GET_REVIEW = 'GET_REVIEW'
export const FETCHREVIEW = 'FETCHREVIEW';